import React, { useState, useEffect, useRef } from "react";
import {
  fetchPostSocial,
  fetchlogoSocial,
  sameSocial,
} from "./apiFolder/index";
import insta from "./icons/instagram New.svg";
import face from "./icons/Facebook new.svg";
import twit from "./icons/Twitter.svg";
import parse from "html-react-parser";
import closeIcon from './icons/close (1).png';

import {
  FacebookShareButton,
  TwitterShareButton,
  LinkedinShareButton,
  EmailShareButton,
  EmailIcon,
  LinkedinIcon,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  WhatsappShareButton,
} from "react-share";
import { useLocation } from "react-router-dom";
import "./App.css";
import { Shimmer } from 'react-shimmer';
import { debounce } from 'lodash';

export default function App() {
  const visiblePosts = useRef(new Set());
  const [posts, setPosts] = useState([]);
  const [logo, setLogo] = useState([]);
  const [interactions, setInteraction] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isShareOption, setIsShareOption] = useState(false);
  const [showModalsupport, setShowModalSupport] = useState(false);
  const [postIndex, setPostIndex] = useState();
  const [loading, setLoading] = useState(true);
  const [loadMore, setLoadMore] = useState(false);
  const [liked, setLiked] = useState(Array(posts.length).fill(false));
  const [help, setHelp] = useState(Array(posts.length).fill(false));
  const [thumbs, setThumbs] = useState(Array(posts.length).fill(false));
  const [share, setShare] = useState(Array(posts.length).fill(false));
  const [support, setSupport] = useState(Array(posts.length).fill(false));
  const [cardCount, setCardCount] = useState(
    new Array(interactions.length).fill(0)
  );
  const { 0: school_id } = useLocation().pathname.split("/").slice(-1);
  const cardRef = useRef(null);
  const [lastProcessedIndex, setLastProcessedIndex] = useState(-1);
  const [hasApiHit, setHasApiHit] = useState(false);
  const [imageLoaded, setImageLoaded] = useState(false);
  const debouncedUpdateViewCount = debounce(viewIncrement, 100);
  const [atEnd, setAtEnd] = useState(false);
  const [scrollPosition, setScrollPosition] = useState(0);
  const [isEndOfScroll, setIsEndOfScroll] = useState(false);
  const [offset, setOffset] = useState(20); // Track offset


  useEffect(() => {
    fetchPostSocial(school_id)
      .then((res) => {
        // console.log("post::::::::::::::::::::", res.data.body.data);
        setPosts(res.data.body.data);
        setLoading(false);
        setInteraction(res.data.body.data);
        setLiked(new Array(res.data.body.length).fill(false));
        setHelp(new Array(res.data.body.length).fill(false));
        setThumbs(new Array(res.data.body.length).fill(false));
        setShare(new Array(res.data.body.length).fill(false));
        setSupport(new Array(res.data.body.length).fill(false));
      })
      .catch((error) => {
        setLoading(false);
      });

    // Fetch Logo
    fetchlogoSocial(school_id)
      .then((res) => {
        // console.log("logo00", res.data.body);
        setLogo(res.data.body);
      })
      .catch((error) => {
      });
  }, []);


  //Added code
  const handleScroll = () => {
    const position = cardRef.current.scrollTop;
    const maxScroll = cardRef.current.scrollHeight - cardRef.current.clientHeight;
    const scrollThreshold = 25; // Define your threshold here

    setScrollPosition(position);
    setIsEndOfScroll(position >= maxScroll - scrollThreshold);
    if (position >= maxScroll - scrollThreshold) {
      setLoadMore(true);
      console.log("<<<<<<<<<<<<<<<POSITION>>>>>>>>>>>>>>> END");
    }
    else {
      setLoadMore(false);
    }
  };


  useEffect(() => {
    if (loadMore) {
      fetchPostSocial(school_id, offset)
        .then((res) => {
          if (res.data.body.data.length > 0) {

            // If new posts are fetched
            const newPosts = res.data.body.data;
            setPosts((prevPosts) => [...prevPosts, ...newPosts]);
            setInteraction((prevInteractions) => [...prevInteractions, ...newPosts]);
            setOffset((prevOffset) => prevOffset + 20);
          } else {
            // If no new posts are fetched
            console.log("No new posts fetched.");
          }
        })
        .catch((error) => {
          console.error('Error fetching more data:', error);
        })
        .finally(() => {
          setLoadMore(false);
        });
    }
  }, [loadMore, offset, school_id]);



  useEffect(() => {
    console.log('Increase view count:::::', lastProcessedIndex);
    debouncedUpdateViewCount()
  }, [debouncedUpdateViewCount, lastProcessedIndex])


  function viewIncrement() {
    const cardElement = cardRef.current;

    if (cardElement) {
      const childElement = cardElement.querySelector(".card");

      if (childElement) {
        const mainWidth = cardElement.clientWidth;
        const mainHeight = cardElement.clientHeight;
        const scrollTop = cardElement.scrollTop;

        const cardWidth = childElement.clientWidth;
        const cardHeight = childElement.clientHeight;

        const totalCol = Math.floor((mainWidth) / (cardWidth));
        const totalRow = Math.floor(mainHeight / (cardHeight));

        const totalDisplayedItems = totalCol * totalRow;

        const xone = Math.floor(scrollTop / cardHeight);
        const xtwo = cardHeight - xone;
        const xthree = scrollTop - xtwo;

        let startIndex = xone * totalDisplayedItems;
        const endIndex = startIndex + totalDisplayedItems - 1;

        if (scrollTop === 0 && !hasApiHit) {
          setLastProcessedIndex(-1);
          setHasApiHit(true);
        } else if (scrollTop > 0) {
          setHasApiHit(false);
        }
        //  if(xthree > cardHeight - 500){ 
        if (startIndex > lastProcessedIndex || endIndex < lastProcessedIndex) {
          setLastProcessedIndex(startIndex);
          console.log('start to end', startIndex, startIndex + totalDisplayedItems);
          const newlyVisible = new Set();
          posts.slice(startIndex, startIndex + totalDisplayedItems).forEach((post) => {
            let newid = post.id;
            let newschoolId = newid.concat(school_id);
            const uniqueKey = `${newschoolId}_view`;
            newlyVisible.add(uniqueKey);
            // Only call API if this post was not visible in the previous scroll
            if (!visiblePosts.current.has(uniqueKey)) {
              postData(newschoolId, post.title, "view");
            }
          });
          visiblePosts.current = newlyVisible;
          //  console.log('start Index', xone * totalDisplayedItems);
          //  console.log('end Index', totalDisplayedItems);
        } else if (startIndex <= lastProcessedIndex) {
          console.log('startIndex is less than or equal to lastProcessedIndex. API will not be hit.');
        }
      }
    } else {
      // console.log('In else of view count::::');
    }
  }
  //----------------------------------------------------------------------------------------
  // Data Post
  const postData = async (notificationId, title, field) => {
    try {
      // console.log("notificationId", notificationId);
      // const notificationId = event;
      const data = {
        Notification_Id__c: notificationId,
        Title__c: title,
        Like__c: "0",
        Thanks__c: "0",
        Share__c: "0",
        Helpful__c: "0",
        Support__c: "0",
        View__c: "0",
        Test_School__c: false,
      };

      if (field === "Like") {
        data.Like__c = "1";
      } else if (field === "Share") {
        data.Share__c = "1";
      } else if (field === "Helpful") {
        data.Helpful__c = "1";
      } else if (field === "Thanks") {
        data.Thanks__c = "1";
      } else if (field === "Support") {
        data.Support__c = "1";
      } else if (field === "view") {
        data.View__c = "1";
      }

      sameSocial(data, school_id)
        .then((respost) => {
          console.log('respost:::::::::::::::::::', respost);
          // fetchPostSocial(school_id, offset)
          //   .then((res) => {
          //       // If new posts are fetched
          //       const newPosts = res.data.body.data;
          //       setInteraction((prevInteractions) => [...prevInteractions, ...newPosts]);
          //   })
          //   .catch((error) => {
          //     console.error('Error fetching more data:', error);
          //   })
        })
        .catch((error) => {
          console.log("error", error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  // modal--------------Start
  const handleClick = (index) => {
    setShowModal(true);
    setPostIndex(index);
    setImageLoaded(false);
    document.documentElement.style.overflowY = "hidden";
  };

  const closeModal = () => {
    setShowModal(false);
    document.documentElement.style.overflowY = "auto";
  };

  const handleClickOutside = (e) => {
    // Check if the click event originated from the child modal of showModalsupport modal
    if (showModalsupport && e.target.classList.contains("sharemodal")) {
      closeModalsupport();
    }
    // Check if the click event originated from the child modal of isShareOption modal
    else if (isShareOption && e.target.classList.contains("sharemodal")) {
      closeModalshare();
    }
    // Check if the click event originated from the parent modal, but not the child modal of isShareOption or showModalsupport modal
    else if (
      !showModalsupport &&
      !isShareOption &&
      e.target.classList.contains("modal") &&
      !e.target.classList.contains("sharemodal")
    ) {
      closeModal();
    }
  };

  useEffect(() => {
    if (showModal || isShareOption || showModalsupport) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal, isShareOption, showModalsupport]);
  // Modal -------- End

  // Close Modal of Share
  const closeModalshare = () => {
    // console.log("-------------", closeModalshare);
    setIsShareOption(false);
    document.body.style.overflow = "auto"; // re-enable background scroll
  };
  const openSupportModel = () => {
    setShowModalSupport(true);
    document.body.style.overflow = "hidden";
  };
  const openShareModal = () => {
    setIsShareOption(true);
    document.body.style.overflow = "hidden"; // disable background scroll
  };
  // Close Modal of Share
  const closeModalsupport = () => {
    // console.log("-------------", closeModalshare);
    setShowModalSupport(false);
    document.body.style.overflow = "auto"; // re-enable background scroll
  };
  // Crad Share Url
  const shareCard = (index) => {
    const currentUrl = window.location.href;
    const url = new URL(currentUrl);
    url.searchParams.set("index", index);
    return url.toString();
  };
  // Count INcrement
  const handleClickin = (event, ind) => {
    const countEl = event.target.parentElement.nextSibling;
    const countStr = countEl.innerHTML.trim(); // remove any leading/trailing whitespace
    const count = parseInt(countStr);

    if (!isNaN(count)) {
      // console.log("event", count + 1);
      countEl.innerHTML = count + 1;
    }

    setCardCount((prevCardCount) => {
      const newCardCount = [...prevCardCount];
      newCardCount[ind] += 1;
      return newCardCount;
    });
    fetchPostSocial(school_id)
      .then((res) => {
        // console.log(res.data.body);
        // setInteraction(res.data.body.data);
        // setLiked(new Array(res.data.length).fill(false));
        // setHelp(new Array(res.data.length).fill(false));
        // setThumbs(new Array(res.data.length).fill(false));
        // setShare(new Array(res.data.length).fill(false));
        // setSupport(new Array(res.data.length).fill(false));
      })
      .catch((error) => {
        console.log(error);
      });
  };
  // localStorage like tracking helpers
  const getLikedPosts = () => {
    try {
      return JSON.parse(localStorage.getItem(`liked_posts_social_${school_id}`) || '[]');
    } catch { return []; }
  };
  const isPostLiked = (postId) => getLikedPosts().includes(postId);
  const savePostLiked = (postId) => {
    const likedPosts = getLikedPosts();
    if (!likedPosts.includes(postId)) {
      likedPosts.push(postId);
      localStorage.setItem(`liked_posts_social_${school_id}`, JSON.stringify(likedPosts));
    }
  };

  // love Button ANimation
  const handleLikeClick = (ind) => {
    const postId = posts[ind]?.id;
    if (isPostLiked(postId)) return;
    savePostLiked(postId);
    const newLikedState = [...liked];
    newLikedState[ind] = true;
    setLiked(newLikedState);
    const updatedPosts = [...posts];
    updatedPosts[ind].interactions.likes += 1;
    setPosts(updatedPosts);
  };
  // Thumbs-Up buttom
  const handleThumbsClick = (ind) => {
    const newLikedState = [...thumbs];
    newLikedState[ind] = true;
    // newLikedState[ind] = !newLikedState[ind];
    setThumbs(newLikedState);
    setTimeout(() => {
      newLikedState[ind] = false;
      setThumbs(newLikedState);
    }, 1000);
  };
  // helpfull button
  const handleHelpfulClick = (ind) => {
    const newLikedState = [...help];
    newLikedState[ind] = true;
    setHelp(newLikedState);
    setTimeout(() => {
      newLikedState[ind] = false;
      setHelp(newLikedState);
    }, 1000);
  };
  // Share Button
  const handleShareClick = (ind) => {
    const newLikedState = [...share];
    newLikedState[ind] = true;
    setShare(newLikedState);
    setTimeout(() => {
      newLikedState[ind] = false;
      setShare(newLikedState);
    }, 1000);
  };
  // Support Button
  const handleSupportClick = (ind) => {
    const newLikedState = [...support];
    newLikedState[ind] = true;
    setSupport(newLikedState);
    setTimeout(() => {
      newLikedState[ind] = false;
      setSupport(newLikedState);
    }, 1000);
  };

  // }
  function NumberFormat(number) {
    if (number === 0) {
      return "0";
    }
    const suffixes = ["", "k", "M", "B", "T"];
    const magnitude = Math.floor(Math.log10(number) / 3);
    const divisor = 10 ** (magnitude * 3);
    const suffix = suffixes[magnitude];
    const shortNumber = (number / divisor).toLocaleString(undefined, {
      maximumFractionDigits: 1,
      minimumFractionDigits: 1,
    });

    if (suffix.length > 0) {
      return shortNumber + suffix;
    } else {
      return parseFloat(shortNumber).toLocaleString();
    }
  }

  const extractText = (html) => {
    let span = document.createElement("span");
    span.innerHTML = html;
    return span.textContent || span.innerText;
  };
  const linkify = (text) => {
    const urlRegex = /(https?:\/\/[^\s]+)/gi;
    // const twitterRegex =/pic.twitter.com\/[\w-]+(?:(?<=\w)-)?/gi;
    const twitterRegex = /pic.twitter.com\/[\w-]+-?[\w-]+/gi;
    const replacedText = text
      .replace(
        urlRegex,
        '<a href="$&" target="_blank" rel="noopener noreferrer">$&</a>'
      )
      .replace(
        twitterRegex,
        '<a href="https://$&" target="_blank" rel="noopener noreferrer">$&</a>'
      );
    return <span dangerouslySetInnerHTML={{ __html: replacedText }} />;
  };
  // Support Email
  function handleEmailClick(email) {
    window.location.href = `mailto:${email}`;
  }
  // Support Calll
  function handlePhoneClick(phoneNumber) {
    window.location.href = `tel:${phoneNumber}`; // initiate phone call
  }
  // Interactions
  function returnInteraction(post, index) {
    let newid = post.id;
    let newschoolId = "";
    let schoopAppC = school_id;
    newschoolId = newid.concat(schoopAppC);
    const combinedLikes = (post.interactions.likes || 0) + (post.interactions.thanks || 0) + (post.interactions.helpful || 0) + (post.interactions.support || 0);
    return (
      <>
        <div className="news-card__action-row">
            <div className="news-card__action-btn">
              <button
                id="like-button"
                onClick={(event) => {
                  if (!isPostLiked(post.id)) {
                    handleLikeClick(index);
                    postData(
                      newschoolId,
                      post.title,
                      "Like"
                    );
                  }
                  handleClickin(event);
                }}
              >
                {(liked[index] || isPostLiked(post.id)) ? (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={liked[index] ? "likesanimation" : ""}>
                    <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#F54438"/>
                  </svg>
                ) : (
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="HeartAnimation">
                    <path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" fill="#F54438"/>
                  </svg>
                )}
              </button>
              <span className="news-card__count">{NumberFormat(combinedLikes)}</span>
            </div>
            <div className="news-card__action-btn">
              <button
                onClick={(event) => {
                  postData(
                    newschoolId,
                    post.title,
                    "Share"
                  );
                  handleShareClick(index);
                  handleClickin(event);
                  openShareModal();
                }}
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="HeartAnimation">
                  <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" fill="#666"/>
                </svg>
              </button>
              {isShareOption && (
                <div className="modal sharemodal">
                  <div className="modal-content share-card">
                    <span className="Close shareclose" onClick={closeModalshare}>&times;</span>
                    <div className="mb-3.5"><p className="ml-2 font-bold text-base">Share With:</p></div>
                    <div className="d-flex contents ml-2">
                      <FacebookShareButton url={shareCard(index)} className="ml-2"><FacebookIcon /></FacebookShareButton>
                      <TwitterShareButton url={shareCard(index)} className="ml-2"><TwitterIcon /></TwitterShareButton>
                      <WhatsappShareButton url={window.location.href} className="ml-2"><WhatsappIcon /></WhatsappShareButton>
                      <LinkedinShareButton url={window.location.href} className="ml-2"><LinkedinIcon /></LinkedinShareButton>
                      <EmailShareButton className="ml-2" url={shareCard(index)}><EmailIcon /></EmailShareButton>
                    </div>
                  </div>
                </div>
              )}
            </div>
        </div>
      </>
    );
  }
  // Function for Pop-up
  function returnInteractionPopUp(post, index) {
    let newid = post.id;
    let newschoolId = "";
    let schoopAppC = school_id;
    newschoolId = newid.concat(schoopAppC);
    for (var i in interactions) {
      if (newid === interactions[i].id) {
        const combinedLikes = (interactions[i].interactions.likes || 0) + (interactions[i].interactions.thanks || 0) + (interactions[i].interactions.helpful || 0) + (interactions[i].interactions.support || 0);
        return (
          <>
            <div className="news-card__action-row" style={{justifyContent: 'center', gap: '20px', padding: '8px 0'}}>
                <div className="news-card__action-btn">
                  <button
                    id="like-button"
                    onClick={(event) => {
                      handleLikeClick(index);
                      postData(newschoolId, post.title, "Like");
                      handleClickin(event);
                    }}
                  >
                    {liked[index] ? (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="likesanimation">
                        <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z" fill="#F54438"/>
                      </svg>
                    ) : (
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="HeartAnimation">
                        <path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" fill="#F54438"/>
                      </svg>
                    )}
                  </button>
                  <span className="news-card__count" style={{fontSize: '15px'}}>{NumberFormat(combinedLikes)}</span>
                </div>
                <div className="news-card__action-btn">
                  <button
                    onClick={(event) => {
                      postData(newschoolId, post.title, "Share");
                      handleShareClick(index);
                      handleClickin(event);
                      openShareModal();
                    }}
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="HeartAnimation">
                      <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" fill="#666"/>
                    </svg>
                  </button>
                  {isShareOption && (
                    <div className="modal sharemodal">
                      <div className="modal-content share-card">
                        <span className="Close shareclose" onClick={closeModalshare}>&times;</span>
                        <div className="mb-3.5"><p className="ml-2 font-bold text-base">Share With:</p></div>
                        <div className="d-flex contents ml-2">
                          <FacebookShareButton url={shareCard(index)} className="ml-2"><FacebookIcon /></FacebookShareButton>
                          <TwitterShareButton url={shareCard(index)} className="ml-2"><TwitterIcon /></TwitterShareButton>
                          <WhatsappShareButton url={window.location.href} className="ml-2"><WhatsappIcon /></WhatsappShareButton>
                          <LinkedinShareButton url={window.location.href} className="ml-2"><LinkedinIcon /></LinkedinShareButton>
                          <EmailShareButton className="ml-2" url={shareCard(index)}><EmailIcon /></EmailShareButton>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
            </div>
          </>
        );
      }
    }
    return (
      <>
        <div className="news-card__action-row" style={{justifyContent: 'center', gap: '20px', padding: '8px 0'}}>
            <div className="news-card__action-btn">
              <button id="like-button">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z" fill="#F54438"/>
                </svg>
              </button>
              <span className="news-card__count" style={{fontSize: '15px'}}>{NumberFormat(0)}</span>
            </div>
            <div className="news-card__action-btn">
              <button>
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z" fill="#666"/>
                </svg>
              </button>
            </div>
        </div>
      </>
    );
  }
  // Description Icon
  function getSourceIconUrl(source) {
    switch (source) {
      case "facebook":
        return face;
      case "instagram":
        return insta;
      case "twitter":
        return twit;
      default:
        return "not found";
    }
  }

  function getPostSource(post) {
    let source = "";
    let link = post.url || ""; // post.link && post.link.match(regex) ? post.link.match(regex)[3] : 'unknown';
    if (link.includes("instagram")) {
      source = "instagram";
    } else if (link.includes("facebook")) {
      source = "facebook";
    } else {
      source = "twitter";
    }
    // console.log("source ", source);
    return source;
  }
  // Arrow Next Index
  function handleClickNext() {
    if (postIndex === posts.length - 1) {
      // do nothing, as we don't want to go forward from the last index
      return;
    } else {
      setPostIndex((postIndex + 1) % posts.length);
      setImageLoaded(false);

    }
  }
  //Arrow Previous  Index
  function handleClickPrev() {
    if (postIndex === 0) {
      // setPostIndex(posts.length - 1);
      return;
    } else {
      setPostIndex((postIndex - 1) % posts.length);
      setImageLoaded(false);
    }
  };


  return (
    <div style={{
      overflowY: 'hidden',
      height: '100vh'
    }}>
      {loading ? (
        <div className="flex justify-center items-center h-screen" style={{ overflowY: 'hidden' }}>
          <div className="w-10 h-10 border-4 border-t-4 loader-blue rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="" style={{
          overflowY: 'hidden'
        }}>
          <div
          className="py-6 px-4 sm:px-6 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-4 mx-auto"
          style={{
            height: '95vh', // Set the height of the scrollable div
            overflowY: 'scroll', // Enable vertical scrolling
          }}

          id="scroll"
          onScroll={handleScroll}
          ref={cardRef}
        >
          {posts &&
            posts.map((post, index) => (
              <React.Fragment key={index}>
              <article
                className={`news-card PostShadow${index === 0 ? ' news-card--featured' : ''}`}
              >
                <div className="news-card__inner">
                  <div className="news-card__media" onClick={() => handleClick(index)}>
                    <img
                      className="w-full h-full object-cover cursor-pointer"
                      src={post.media}
                      alt="Card"
                      onError={(e) => {
                        e.target.src = logo.Full_Logo__c;
                      }}
                    />
                  </div>
                  <div className="news-card__body">
                    <div className="flex items-center gap-2 mb-2">
                      <img
                        src={getSourceIconUrl(getPostSource(post))}
                        alt="Post source icon"
                        className="setimage feedsetimage"
                      />
                      <a
                        href={post.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-semibold text-sm hover:text-red-500"
                      >
                        {post.creator}
                      </a>
                    </div>
                    <time className="news-card__date">
                      {new Date(post.date).toLocaleDateString("en-US", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "2-digit",
                      })}
                    </time>
                    <p
                      className={`news-card__excerpt cursor-pointer ${post.description && post.description.includes("<a>") ? "blur" : ""}`}
                      onClick={() => handleClick(index)}
                    >
                      {parse(extractText(post.description))}
                    </p>
                    <footer className="news-card__footer">
                      <span className="news-card__views">{post.interactions.views} views</span>
                      <div className="news-card__actions">{returnInteraction(post, index)}</div>
                    </footer>
                  </div>
                </div>
              </article>
                    {postIndex === index && showModal && (
                      <div
                        id="showmodalopen"
                        className="modal fullcard"
                        onClick={handleClickOutside}
                      >
                        <div className="prevbtn mr-12 sm:mr-1 md:mr-8">
                          <span
                            className="prev-arrow cursor-pointer prevbtn"
                            onClick={handleClickPrev}
                          >
                            &#10094;
                          </span>
                        </div>
                        <div className="modal-content modal-card modal-card-modern xl:w-3/5 lg:w-4/5 md:w-4/5 sm:w-4/5 relative">
                          <div className="modal-close-row">
                            <div className="Close-modal" onClick={closeModal}>
                              <img className="Close-image" src={closeIcon} alt="Close" />
                            </div>
                          </div>
                          <div className="modal-scroll-area">
                            {/* Header: source icon, creator, date */}
                            <div className="modal-header-modern">
                              <div className="modal-header-top">
                                <img
                                  src={getSourceIconUrl(getPostSource(post))}
                                  alt="Post source icon"
                                  className="setimage"
                                  style={{ width: '40px', height: '40px', borderRadius: '10px', objectFit: 'contain', border: '1px solid #e5e7eb' }}
                                />
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                                  <a
                                    href={post.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="font-semibold hover:text-red-500"
                                    style={{ fontSize: '14px', color: '#111827', textDecoration: 'none' }}
                                  >
                                    {post.creator}
                                  </a>
                                  <time className="modal-date-modern">
                                    {new Date(post.date).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).toUpperCase()}
                                  </time>
                                </div>
                              </div>
                              <div className="modal-desc-modern">
                                {linkify(extractText(post.description))}
                              </div>
                            </div>

                            {/* Media */}
                            <div style={{ padding: '12px 0' }}>
                              <div className="flex justify-center">
                                {!imageLoaded && (
                                  <Shimmer
                                    className="w-full h-full shimmcolor"
                                    height={500}
                                    width={2000}
                                    style={{ objectFit: "cover" }}
                                    duration={1000}
                                  />
                                )}
                                <div className="relative image-wrapper">
                                  <img
                                    className="w-full object-contain post-image"
                                    src={
                                      posts[postIndex].media ||
                                      posts[postIndex].media ||
                                      logo.Full_Logo__c
                                    }
                                    onError={(e) => {
                                      e.target.src = logo.Full_Logo__c;
                                    }}
                                    alt="Card"
                                    onLoad={() => setImageLoaded(true)}
                                    style={{
                                      display: imageLoaded ? "block" : "none",
                                      borderRadius: '12px',
                                      maxHeight: '500px',
                                    }}
                                  />
                                  <div className="zoominlogo">
                                    <a href={posts[postIndex].media ||
                                      posts[postIndex].media}
                                      target="_blank" rel="noopener noreferrer">
                                      <svg width="498" height="499" viewBox="0 0 498 499" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M425.733 1.33323C419.467 3.86656 418.267 11.7332 423.333 16.6666C426.4 19.8666 427.2 19.9999 445.6 19.9999H464.667L395.6 89.0666C346.933 137.733 326.667 158.933 326.667 160.933C326.667 164.267 331.733 170.4 334.667 170.8C335.733 170.933 337.867 170.933 339.333 170.8C340.933 170.667 369.2 143.467 410.267 102.4L478.667 33.9999V53.4666C478.667 74.6666 479.2 76.1332 486.8 77.9999C489.467 78.6666 491.2 77.9999 494.133 75.5999L498 72.2666V39.3332V6.39989L494.267 3.19989C490.533 -0.000106569 490.4 -0.000106569 459.6 0.133227C442.533 0.133227 427.333 0.66656 425.733 1.33323Z" fill="white" />
                                        <path d="M42.6667 52.5335C20.6667 57.3335 4.8 74.2668 1.33333 96.8002C0.399995 102.933 -4.53168e-06 151.467 0.266662 241.733L0.666662 377.333L61.3333 438L122 498.667H260.8C409.867 498.667 406.667 498.8 420.267 491.867C432.533 485.6 443.467 470.8 446.533 456.267C447.6 451.2 448 401.467 448 284.933V120.8L438 130.667L428 140.533L427.733 298L427.333 455.333L424.4 460.667C421.067 466.933 415.867 472 409.333 475.467C404.933 477.867 398.4 478 270.4 478.4L136.267 478.667L135.733 437.067C135.2 401.333 134.8 394.4 132.8 389.067C129.733 380.8 121.867 372.133 113.867 368C107.333 364.667 106.933 364.667 64 364L20.6667 363.333V229.333V95.3335L24.6667 88.1335C28.9333 80.4002 36.6667 74.4002 45.3333 72.0002C48.2667 71.2002 107.333 70.6668 204 70.6668H358.133L367.067 61.6002C372 56.6668 376 52.1335 376 51.6002C376 51.0668 302.667 50.6668 213.067 50.8002C91.4667 50.8002 48.1333 51.3335 42.6667 52.5335ZM100.667 384.133C108 386.133 114.267 393.2 115.333 400.4C115.733 403.467 116 419.067 115.733 435.067L115.333 464L74.6667 423.333L34 382.667H64.6667C82.9333 382.667 97.4667 383.333 100.667 384.133Z" fill="white" />
                                      </svg>
                                    </a>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          {/* Sticky footer */}
                          <div className="modal-footer-modern">
                            <span className="modal-views-modern">{post.interactions?.views || 0} views</span>
                            <div className="modal-footer-actions">{returnInteractionPopUp(post, index)}</div>
                          </div>
                        </div>
                        <div className="nxtbtn ml-12 sm:ml-1 md:ml-8">
                          <span
                            className="next-arrow cursor-pointer nxtbtn"
                            onClick={handleClickNext}
                          >
                            &#10095;
                          </span>
                        </div>
                      </div>
                    )}
              </React.Fragment>
            ))}
        </div>
        </div>
      )}
      {/* Conditional rendering of loader */}
      {loadMore && (
        <div className="flex justify-center items-center">
          <div className="w-10 h-10 border-4 border-t-4 loader-blue rounded-full animate-spin"></div>
        </div>
      )}
    </div>
  );
}
